import styled from "styled-components";
import {facebook, google, lightenDarkenColor} from "../colors";

export const Button = styled.button`
  border-radius: 0;
  padding: 0 40px;
  border: none;
  text-transform: uppercase;
  color: white;
  font-weight: bold;
  font-size: 14px;
  cursor: pointer;
  text-decoration: none;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:focus {
    outline: none;
  }

  &[disabled],
  &[disabled]:hover {
    background-color: grey;
    cursor: not-allowed;
  }

  @media only screen and (max-width: 767px) {
    padding: 0 20px;
  }
`;

export const PrimaryButton = styled(Button)`
  background-color: ${({theme}) => theme.primary};
  &:hover {
    background-color: ${({theme}) => theme.lightPrimary};;
  }
`;

export const OutlineButton = styled(Button)`
  background-color: transparent;
  color: black;
  border: 1px black solid;
  font-weight: normal;

  &:hover {
    background-color: transparent;
  }
`;

export const LinkButton = styled.a`
  border-radius: 0;
  padding: 0 40px;
  border: none;
  color: white;
  font-weight: bold;
  font-size: 14px;
  cursor: pointer;
  text-decoration: none;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:focus {
    outline: none;
  }

  @media only screen and (max-width: 767px) {
    padding: 0 20px;
  }
`;

export const PrimaryLinkButton = styled(LinkButton)`
  text-transform: uppercase;
  background-color: ${({theme}) => theme.primary};
  &:hover {
    background-color: ${({theme}) => theme.lightPrimary};;
  }
`;

export const GoogleButton = styled(LinkButton)`
  background-color: ${google};

  &:hover {
    background-color: ${lightenDarkenColor(google, 20)};
  }
`;

export const FacebookButton = styled(LinkButton)`
  background-color: ${facebook};

  &:hover {
    background-color: ${lightenDarkenColor(facebook, 20)};
  }
`;
